import React from 'react';
import { BasicContainer, FlexDynamic } from '@minecraft.atoms';
import { BasicLayout } from './BasicLayout';
import { TwoColumnLayoutProps } from './types';

export const TwoColumnLayout = <NavKey extends string>({
  header,
  leftChildren,
  rightChildren,
  pageTitle,
  subNavProps,
  pageBgColor,
  bodyMaxWidth,
  'data-testid': dataTestId = 'two-column-layout',
}: TwoColumnLayoutProps<NavKey>) => {
  return (
    <BasicLayout
      header={header}
      subNavProps={subNavProps}
      pageTitle={pageTitle}
      pageBgColor={pageBgColor}
      bodyMaxWidth={bodyMaxWidth}
      data-testid={dataTestId}
    >
      <FlexDynamic h="full" w="full" wrap="nowrap" direction="column" mdProps={{ direction: 'row' }}>
        <BasicContainer data-testid="left-column" h="full" w="full">
          {leftChildren}
        </BasicContainer>
        <BasicContainer data-testid="right-column" h="full" w="full">
          {rightChildren}
        </BasicContainer>
      </FlexDynamic>
    </BasicLayout>
  );
};
